__turbopack_context__.v({
  "budget": "budget-visual-module__rSIgrG__budget",
  "client": "budget-visual-module__rSIgrG__client",
  "dot": "budget-visual-module__rSIgrG__dot",
  "fill": "budget-visual-module__rSIgrG__fill",
  "flag": "budget-visual-module__rSIgrG__flag",
  "flagOff": "budget-visual-module__rSIgrG__flagOff",
  "footer": "budget-visual-module__rSIgrG__footer",
  "head": "budget-visual-module__rSIgrG__head",
  "hideNarrow": "budget-visual-module__rSIgrG__hideNarrow",
  "hours": "budget-visual-module__rSIgrG__hours",
  "meter": "budget-visual-module__rSIgrG__meter",
  "name": "budget-visual-module__rSIgrG__name",
  "nr": "budget-visual-module__rSIgrG__nr",
  "pct": "budget-visual-module__rSIgrG__pct",
  "root": "budget-visual-module__rSIgrG__root",
  "row": "budget-visual-module__rSIgrG__row",
  "rows": "budget-visual-module__rSIgrG__rows",
  "track": "budget-visual-module__rSIgrG__track",
  "year": "budget-visual-module__rSIgrG__year",
});
